module.exports = __webpack_public_path__ + "img/LongSleeve.dcdf3993.jpg";